export default {
  labels: {
    dwellingSize: { en: "Build Up Area" },
    dwellingBeds: { en: "Rooms" },
    dwellingCars: { en: "Parking" },
  },

  general: {
    showFavourites: true,
    showSoldPrice: false,
    appResetTimeoutMinutes: 15,
  },

  filter: {
    enabled: false,
  },
};
